import { STATE_CONTEXT } from './TOKENS.js';

/**
 * Registers the state globally, but only if no state has already been set.
 * @param {object} state 
 */

export function provideState(state) {
  if (!globalThis[STATE_CONTEXT]) {
    globalThis[STATE_CONTEXT] = state;
  }
}

export function hasState() {
  return globalThis[STATE_CONTEXT] !== undefined;
}

/**
 * Forcefully override the state in the global context.
 * Useful for testing or resetting.
 */
export function forceState(state) {
  globalThis[STATE_CONTEXT] = state;
}

/**
 * Retrieves the globally registered state.
 */
export function getState() {
  return globalThis[STATE_CONTEXT] || null;
}

/**
 * Retrieves the globally registered state.
 */
export function useState() {
  return getState();
}

export function clearState() {
  globalThis[STATE_CONTEXT] = undefined;
}